import React from 'react';
import { useCurrentTeaAction, useCurrentTeaAttrs, useCurrentTeaCup, } from '@saucerjs/core';
import { TeaAttrsContext } from './context/TeaAttrsContext';
/**
 * Inspector of cup
 *
 * Render Cup Attrs Editor Component
 */
export var Inspector = React.memo(function (props) {
    var currentTeaAttrs = useCurrentTeaAttrs();
    var currentCup = useCurrentTeaCup();
    var setCurrentTeaAttrs = useCurrentTeaAction().setCurrentTeaAttrs;
    var Editor = currentCup === null || currentCup === void 0 ? void 0 : currentCup.editor;
    return (React.createElement("div", { className: "saucer-editor-inspector", style: props.style },
        React.createElement(TeaAttrsContext.Provider, { value: { currentTeaAttrs: currentTeaAttrs, setCurrentTeaAttrs: setCurrentTeaAttrs } }, Editor ? (React.createElement(Editor, null)) : (React.createElement("div", { style: { textAlign: 'center' } }, "Please Select any Element")))));
});
Inspector.displayName = 'Inspector';
